import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import store from "./Store/store";
import { Provider } from "react-redux";
import AppSettingsService from "./Services/AppSettingsService";
import { primaryTheme } from "./themes";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from 'react-dom/client';
export const appSettings = new AppSettingsService();
// export const authService = new AuthService(appSettings);
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={primaryTheme}>
          {/* <DialogProvider>
            <PopperProvider>
              <DrawerProvider> */}
                <App />
              {/* </DrawerProvider>
            </PopperProvider>
          </DialogProvider> */}
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
